import { Injectable } from '@angular/core';
import { MetadataResource } from './metadata.resource';

@Injectable({
  providedIn: 'root',
})
export class MetadataLanguageService extends MetadataResource {
  constructor() {
    super('language');
  }
}
